<template>
  <div class="pa-6" style="background-color: #F4F7FE; min-height: 100vh;">
    <h1 class="text-h4 font-weight-black mb-6" style="color: #1B2559;">Editar Usuario</h1>
    
    <form-usuario v-if="usuario.id" :usuario="usuario" @guardado="onGuardar" />
    
    <v-overlay :value="cargando">
      <v-progress-circular indeterminate size="64" color="#4318FF"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" color="success" top rounded="pill">
        {{ mensajeTexto }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import FormUsuario from './FormUsuario.vue'

export default {
  components: { FormUsuario },
  data: () => ({ 
    cargando: false, 
    usuario: {},
    mostrarMensaje: false,
    mensajeTexto: ""
  }),
  mounted() {
    this.obtenerDatos();
  },
  methods: {
    obtenerDatos() {
      this.cargando = true;
      HttpService.obtenerConDatos({ 
        metodo: "un_usuario", 
        id: this.$route.params.id 
      }, "usuarios.php")
      .then(res => { 
        this.usuario = res; 
        this.cargando = false; 
      });
    },
    onGuardar(payload) {
      this.cargando = true;
      
     
      const fd = new FormData();
      fd.append("metodo", "put");
      fd.append("idSolicitante", localStorage.getItem("idUsuario"));
      
    
      fd.append("usuario_data", JSON.stringify(payload.datos));

    
      if (payload.foto) {
        fd.append("foto", payload.foto);
      }

      HttpService.registrar(fd, "usuarios.php").then(res => {
        this.cargando = false;
        if (res === true || (res && res.resultado !== false)) {
          this.mensajeTexto = "Información actualizada correctamente";
          this.mostrarMensaje = true;
          setTimeout(() => this.$router.push({ name: "Usuarios" }), 1500);
        } else {
          alert("Error al actualizar: " + (res.mensaje || "Error desconocido"));
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/EditarUsuario.vue